import React, { useState } from 'react';

interface UserInfoProps {
    onSubmitUserInfo: (info: { email: string; password: string }) => void;
}

const UserInfo: React.FC<UserInfoProps> = ({ onSubmitUserInfo }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        onSubmitUserInfo({ email, password });
    };

    return (
        <div className="flex items-center justify-center h-full">
            <div className="w-full max-w-md p-6 bg-stone rounded-lg shadow-md">
                <h2 className="text-2xl font-bold text-center text-terracotta font-cinzel mb-4">User Information</h2>
                <form onSubmit={handleSubmit} className="space-y-3">
                    <div>
                        <label htmlFor="email" className="block text-sm font-bold text-stone-dark font-cinzel">Email</label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full px-3 py-2 mt-1 text-stone-dark border border-stone-dark rounded-md focus:outline-none focus:ring-2 focus:ring-terracotta"
                            required
                        />
                    </div>
                    <div>
                        <label htmlFor="password" className="block text-sm font-bold text-stone-dark font-cinzel">Password</label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full px-3 py-2 mt-1 text-stone-dark border border-stone-dark rounded-md focus:outline-none focus:ring-2 focus:ring-terracotta"
                            required
                        />
                    </div>
                    <button
                        type="submit"
                        className="w-full px-4 py-2 text-warm-cream bg-terracotta rounded-md hover:bg-golden-yellow hover:text-stone-dark transition duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-golden-yellow focus:ring-offset-2 font-cinzel font-bold"
                    >
                        Continue
                    </button>
                </form>
            </div>
        </div>
    );
};

export default UserInfo;